import {useEffect, useState, useRef, useCallback} from 'react'
import {Modal} from 'react-bootstrap'
import {useSelector} from 'react-redux'
import {getAllUserDetails} from '../../../../UserPages/accounts/Overview/OverviewSlice/UserDetailsSlice'
import Select from 'react-select'
import moment from 'moment'

import {useLazyGetCouponListQuery} from '../../../../../../services/cellcast.v2'
import {ROLES} from '../../../../../Utils/Constant/roles'

const AssignCoupon = ({show, handleClose, handleSubmit}: any) => {
  const [selectedCoupon, setSelectedCoupon] = useState<any>(null)
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState<string>('')
  const debounceTimerRef = useRef<NodeJS.Timeout | null>(null)

  const userDetail = useSelector(getAllUserDetails)

  const [fetch, {data, isFetching}] = useLazyGetCouponListQuery()

  const ClosePopup = () => {
    handleClose()
  }

  useEffect(() => {
    fetch({
      staffId: userDetail?.role !== ROLES.SUPER_ADMIN ? userDetail?._id : '',
      page: 1,
      limit: 50,
      search: debouncedSearchTerm,
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userDetail?._id, debouncedSearchTerm])

  const handleSearchChange = useCallback((inputValue: string) => {
    if (debounceTimerRef.current) {
      clearTimeout(debounceTimerRef.current)
    }
    debounceTimerRef.current = setTimeout(() => {
      setDebouncedSearchTerm(inputValue)
    }, 500)
  }, [])

  useEffect(() => {
    return () => {
      if (debounceTimerRef.current) {
        clearTimeout(debounceTimerRef.current)
      }
    }
  }, [])

  return (
    <>
      <Modal
        id='kt_modal_create_app'
        tabIndex={1}
        aria-hidden='true'
        dialogClassName='modal-dialog-centered mw-600px'
        className='vh-100 '
        size='sm'
        show={show}
        onHide={ClosePopup}
      >
        <div className='modal-header'>Add Coupon</div>
        <div className='modal-body p-8'>
          <div className='col'>
            <label className='col-form-label fw-bold fs-6'>Coupon</label>

            <div className='row'>
              <div className='col fv-row'>
                <Select
                  name='coupon'
                  options={
                    data?.data?.items?.map((key: any) => ({
                      value: key?._id,
                      label: key?.code,
                      data: key,
                    })) || []
                  }
                  onChange={(option: any) => setSelectedCoupon(option?.data)}
                  onInputChange={handleSearchChange}
                  isLoading={isFetching}
                  filterOption={() => true}
                  placeholder='Search coupon...'
                />
                <div className='fv-plugins-message-container'>
                  <div className='fv-help-block text-danger'></div>
                </div>
              </div>
            </div>
            <div className='row'>
              <div className='col-12 mt-4 p-3 border rounded'>
                <label className='col-form-label fw-bold fs-6 mb-2'>Coupon Detail</label>
                <div className='d-flex flex-column gap-2'>
                  <div className='d-flex justify-content-between'>
                    <span>Coupon Code:</span>
                    <span className='fw-bold'>{selectedCoupon?.code}</span>
                  </div>
                  <div className='d-flex justify-content-between'>
                    <span>Description:</span>
                    <span className='fw-bold'>{selectedCoupon?.description}</span>
                  </div>
                  <div className='d-flex justify-content-between'>
                    <span>Discount Amount:</span>
                    <span className='fw-bold'>
                      {selectedCoupon?.discountType === 'fixed_price'
                        ? selectedCoupon?.flatRate
                        : `${selectedCoupon?.percentageOff}%`}
                    </span>
                  </div>
                  <div className='d-flex justify-content-between'>
                    <span>Min. Purchase Credit:</span>
                    <span className='fw-bold'>{selectedCoupon?.minCredit}</span>
                  </div>
                  <div className='d-flex justify-content-between'>
                    <span>Max. Purchase Credit:</span>
                    <span className='fw-bold'>{selectedCoupon?.maxCredit}</span>
                  </div>
                  <div className='d-flex justify-content-between'>
                    <span>Type:</span>
                    <span className='fw-bold'>{selectedCoupon?.type}</span>
                  </div>
                  <div className='d-flex justify-content-between'>
                    <span>Expired:</span>
                    <span className='fw-bold'>
                      {selectedCoupon?.expiredDay
                        ? moment()
                            .add(selectedCoupon.expiredDay, 'days')
                            .format('DD/MMM/YYYY HH:mm')
                        : 'N/A'}
                    </span>
                  </div>
                  <div className='d-flex justify-content-between'>
                    <span>Commission:</span>
                    <span className='fw-bold'>
                      {`${selectedCoupon?.commisionRate ?? 0}%` || 'N/A'}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className='d-flex flex-center mt-5'>
            <div id='kt_drawer_chat_close'>
              <button
                type='button'
                onClick={() => {
                  ClosePopup()
                }}
                className='btn btn-sm btn-light text-hover-white bg-white btn-active-primary text-primary me-2 w-100px p-3 fw-500 me-2'
              >
                Cancel
              </button>
            </div>

            <button
              type='submit'
              className='btn btn-sm btn-light btn-primary fw-500   w-100px p-3 border border-primary'
              onClick={() => handleSubmit(selectedCoupon?._id)}
            >
              <span className='indicator-label'>Submit</span>
            </button>
          </div>
        </div>
      </Modal>
    </>
  )
}

export default AssignCoupon
